import { __, sprintf } from '@web-stories-wp/i18n';
import { Text, THEME_CONSTANTS } from '@web-stories-wp/design-system';
import Dialog from '@web-stories-wp/story-editor/src/components/dialog';

function PagesValidationDialog({ isOpen, onClose, onClick, validationResult }) {
  const issue = validationResult[0];
  const element = issue.element;
  const assetName = element?.resource?.title ?? element?.resource?.alt;
  return (
    <Dialog
      title="An error occurred while saving the Story"
      isOpen={isOpen}
      onClose={onClose}
      ariaHideApp={false}
      primaryText="Ok"
      onPrimary={onClick}
    >
      {issue.kind === 'lottie-copy' ? (
        <Text
          role="alert"
          size={THEME_CONSTANTS.TYPOGRAPHY.PRESET_SIZES.MEDIUM}
        >
          {sprintf(
            /* translators: 1: Page number. 2: Copy validation message. */
            __('Page %1$d: %2$s', 'web-stories'),
            issue.pageNumber,
            issue.message
          )}
        </Text>
      ) : (
        validationResult?.length > 0 && (
          <>
            <Text size={THEME_CONSTANTS.TYPOGRAPHY.PRESET_SIZES.MEDIUM}>
              There was a problem uploading the selected asset:
            </Text>
            <Text isBold size={THEME_CONSTANTS.TYPOGRAPHY.PRESET_SIZES.MEDIUM}>
              Page {validationResult[0].pageNumber}: {assetName}{' '}
              {element.isBackground && '(background)'}
            </Text>
            <Text size={THEME_CONSTANTS.TYPOGRAPHY.PRESET_SIZES.MEDIUM}>
              Please re-upload this asset and try again.
            </Text>
          </>
        )
      )}
    </Dialog>
  );
}

export default PagesValidationDialog;
